import styled, { css } from 'styled-components';

export const SubtitleCss = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`;

export default styled.span`
  ${SubtitleCss}
`;
